import {connect} from 'react-redux'
import axios from 'axios';
import {createRef, useEffect, useState} from 'react';
import {defaultBg} from '../../defaults'
import {login, logout} from "../../action/auth";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import "../../style.css"
import "./home.css"
import axiosHandler from "../../services/https";

const Home = ({isOperator, isAuthenticated, maintenance, login, logout}) => {

    const [bg, setBg] = useState(defaultBg);
    const [webgisUrl, setWebgisUrl] = useState(null);
    const {
        backgroundImg,
        homeTitle,
        homeDescription,
        homeId,
        loginBtnImg
    } = bg;

    const callLogin = () => {
        if (isAuthenticated) {
            logout(true);
        } else {
            login();
        }
    }

    const fetchBg = () => {
        axiosHandler.getInstance().get(`${process.env.REACT_APP_API_URL}/bg`).then(res => {
            const newBg = {...res.data[0], homeId: res.data[0].id};
            console.log('Background has changed');
            setBg(newBg);

        }).catch(err => {
            console.log('Using previous homepage');
        });
    }

    useEffect(() => {
        if (homeId === 0) {
            fetchBg();
        }
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            const qs = "";
            setWebgisUrl(`${process.env.REACT_APP_WEBGIS_API_ADDRESS}${qs}`);
        }
    }, [isAuthenticated]);

    return (
        isAuthenticated ?
           ( !isOperator ?
            <>
                <iframe style={{width: '100%', paddingTop: '90px', minHeight: 'calc(100vh - 105px)'}} src={webgisUrl}/>
            </> :
            <>
            <div className='glob'>
                <>
                    <div className='home-container' style={{backgroundImage: `url(${"../static/images/" + (backgroundImg)}`}}>
                        <Container>
                            <Row className='align-items-center justify-content-left' style={{minHeight: 'calc(100vh - 200px'}}>
                                <Col className='col-12'>
                                    <Row className="home-text1">
                                        <Col>{homeTitle}</Col>
                                    </Row>
                                    <Row className="home-text">
                                        <Col>WELCOME</Col>
                                    </Row>
                                    <Row className="home-text">
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </>
            </div>
            </>
           ) :
            <div className='glob'>
                <>
                    <div className='home-container' style={{backgroundImage: `url(${"../static/images/" + (backgroundImg)}`}}>
                        <Container>
                            <Row className='align-items-center justify-content-left' style={{minHeight: 'calc(100vh - 200px'}}>
                                <Col className='col-12'>
                                    <Row className="home-text1">
                                        <Col>{homeTitle}</Col>
                                    </Row>
                                    <Row className="home-text">
                                        <Col>{homeDescription}</Col>
                                    </Row>
                                    <Row className="home-text">
                                        <Col className="col-2">
                                            <Button onClick={() => {
                                                callLogin()
                                            }}>
                                                LOGIN
                                            </Button>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </>
            </div>
    )
}

const mapStateToProps = state => ({
    maintenanceStatus: state.auth.maintenanceStatus,
    isAuthenticated: state.auth.isAuthenticated,
    isOperator: state.auth.isOperator
});

export default connect(mapStateToProps, {login, logout})(Home);
